import { SortBy } from '@fc-shared/ui/sort-by/sort-by';

export const changeSortByListOrder = (
  sortByList: SortBy[],
  actionSortBy: SortBy,
) => {
  return sortByList.map((sortBy) => {
    if (sortBy.value === actionSortBy.value) {
      return {
        ...sortBy,
        order: sortBy.order === null ? true : !actionSortBy.order,
      };
    } else {
      return { ...sortBy, order: null };
    }
  });
};
